import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const underlineStyles = css `
  background-position: 100% 100%;
  background-size: 100% ${pxToRem(1)};
`;
const commonStyles = css `
  background-image: linear-gradient(currentcolor 0 0);
  background-position: 0 100%;
  background-size: 0% ${pxToRem(1)};
  background-repeat: no-repeat;
  transition:
    color 0.25s,
    outline 0.25s,
    background-size 0.25s,
    background-position 0s 0.25s;
  transition-timing-function: ease;
  outline-color: transparent;

  &:hover,
  &:focus-visible,
  &:active {
    ${underlineStyles};
    background-image: linear-gradient(currentcolor 0 0);
  }

  &:focus-visible {
    outline: ${pxToRem(4)} solid;
    border-radius: ${theme.borderRadius.sm};
  }
`;
const primaryStyles = css `
  color: ${theme.swatches.blue[500]};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${theme.swatches.blue[100]} 0 0);

      &:focus-visible {
        color: ${theme.swatches.blue[700]};
      }
    `}

  &:hover {
    color: ${theme.swatches.blue[500]};
  }

  &:focus-visible {
    color: ${theme.swatches.blue[500]};
    outline-color: ${theme.swatches.blue[100]};
    background-image: linear-gradient(${theme.swatches.blue[100]} 0 0);
  }

  &:active {
    color: ${theme.swatches.blue[700]};
  }
`;
const text200Styles = css `
  color: ${theme.semantic.foreground.secondary};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${theme.semantic.border.default} 0 0);
    `}

  &:hover {
    color: ${theme.semantic.foreground.secondary};
  }

  &:focus-visible {
    color: ${theme.semantic.foreground.secondary};
    outline-color: ${theme.semantic.focus.ring};
    background-image: linear-gradient(transparent 0 0);
  }

  &:active {
    color: ${theme.semantic.foreground.primary};
  }
`;
const text300Styles = css `
  color: ${theme.semantic.foreground.primary};
  ${commonStyles};

  ${({ $underline }) => $underline &&
    css `
      ${underlineStyles};
      background-image: linear-gradient(${theme.semantic.border.default} 0 0);
    `}

  &:hover {
    color: ${theme.semantic.foreground.primary};
  }

  &:focus-visible {
    color: ${theme.semantic.foreground.primary};
    outline-color: ${theme.semantic.focus.ring};
    background-image: linear-gradient(transparent 0 0);
  }

  &:active {
    color: ${theme.semantic.foreground.secondary};
    background-image: linear-gradient(${theme.swatches.gray[700]} 0 0);
  }
`;
export function linkAppearance(appearance) {
    switch (appearance) {
        case 'text-200':
            return text200Styles;
        case 'text-300':
            return text300Styles;
        case 'primary':
        default:
            return primaryStyles;
    }
}
